'use strict';

module Patersons {
    export class Account {
        id: number;
        accountType: string;
        accountId: string;
        accountName: string;
        adviserCode: string;
        adviserName: string;
        totalCost: number;
        totalHoldingsValue: number;
        totalEstimatedAnnualIncome: number;
        totalHoldingsProfit: number;
        totalMovementToday: number;
        totalMovementPercentage: number;
        homePhoneNumber: string;
        workPhoneNumber: string;
        mobilePhoneNumber: string;
        email: string;
        emailContractNotes: string;
        pricesQuotedAt: any;
        registrationAddress: Address;
        postalAddress: Address;
        accountAddresses: AccountAddresses;
        residentialOrBusinessAddress: Address;
        creditBankAccount: BankAccountDetail;
        debitBankAccount: BankAccountDetail;
        holdings: Array<Holding>;
        cashDeposits: Array<CashDeposit>;
        termDeposits: Array<TermDeposit>
        emailAddresses: Array<EmailAddress>;
        orderRequests: Array<OrderRequest>;
        confirmationNotes: Array<ConfirmationNote>;
        marketOrders: Array<any>;
        reports: Array<any>;
        isChessManaged: boolean;
        isAccolade: boolean;
        designation: string;
        bankingDetails: BankingDetails;
        hasTaxFileNumber: boolean;
        headerLoaded: boolean = false;
        summaryLoaded: boolean = false;
        summaryError: boolean = false;
        headerError: boolean = false;
        addressLine1: string;
        addressLine2: string;
        addressLine3: string;
        addressLine4: string;
        postcode: string;
        country: string;
        isAuthorisedAgentAccount: boolean = false;
    }
    export class AccountAddresses {
        residentialOrBusinessAddress: Address;
        registrationAddress: Address;
        postalAddress: Address;
    }

    export class BankingDetails {
        creditBankAccount: BankAccountDetail;
        debitBankAccount: BankAccountDetail;
    }


    // NOTE: In the UI templates, these are referred to as 'Contract Notes'.
    export class ConfirmationNote {
        id: number;
        investorPortfolioId: number;
        conNumber: string;
        conDate: Date;
        securityCode: string;
        securityDescription: string;
        type: string;
        units: number;
        currencyCode: string;
        nett: number;
        isSelected: boolean;
        uri: string;
        prettyFileName: string;
    }

    export class Holding {

        constructor(marketValue?: number, totalCost?: number, assetCategory?: string, isin?: string, securityName?: string) {
            this.marketValue = marketValue;
            this.totalCost = totalCost;
            this.assetCategory = assetCategory;
            this.isin = isin;
            this.securityName = securityName;
        }
        id: number;
        securityName: string;
        assetCategory: string;
        companyName: string;
        securityCode: string;
        isin: string;
        quantity: number;
        totalCost: number;
        averageCost: number;
        isInternational: boolean;
        lastPrice: number;
        exchange: string;
        marketValue: number;
        profitOrLoss: number;
        dividendPerShare: number;
        assetAllocationDomesticCash: number;
        assetAllocationDomesticEquity: number;
        assetAllocationDomesticFixedInterest: number;
        assetAllocationDomesticProperty: number;
        assetAllocationInternationalCash: number;
        assetAllocationOther: number;
        assetAllocationInternationalEquity: number;
        assetAllocationInternationalFixedInterest: number;
        assetAllocationInternationalProperty: number;
        frankedAmount: number;
        income: number;
        yield: number;
        priceToEarnings: number;
        asOf: Date;
    }

    export class Sector {
        sectorName: string;
        count: number;
    }
    export class BankAccountDetail {
        id: number;
        accountName: string;
        accountBSB: string;
        accountNumber: string;
        depositDividends: boolean;
        isChessManaged: boolean;
        cardType: string;
        serviceType: string;
        smsToken: string;
    }

    export class CashDeposit {
        id: number;
        instituteCode: string;
        accountName: string;
        balance: number;
        interestRate: number;
        type: string;
    }

    export class TermDeposit {
        accountCode: string;
        balance: number;
        rate: number;
        maturityDate: Date;
        provider: string;
        hasData(): boolean {
            return ((typeof this.accountCode != 'undefined' && this.accountCode) ||
                (typeof this.balance != 'undefined' && this.balance) ||
                (typeof this.rate != 'undefined' && this.rate) ||
                (typeof this.maturityDate != 'undefined' && this.maturityDate) ||
                (typeof this.provider != 'undefined' && this.provider)
            ) as any;
        }
    }

    export class Quote {
        securityCode: string;
        exchange: string;
        askPrice: number;
        askVolume: number;
        bidCount: number;
        bidPrice: number;
        bidVolume: number;
        totalVolume: number;
        totalValue: number;
        highPrice: number;
        lastPrice: number;
        lowPrice: number;
        matchPrice: number;
        matchVolume: number;
        marketValue: number;
        marketVolume: number;
        movement: number;
        openPrice: number;
        quotationBasisCode: string;
        tradingStatus: string;
        tradeCount: number;
        tradeDateTime: Date;
        updateDateTime: Date;
        previousClosePrice: number;

    }

    export class Address {
        id: number;
        address1: string;
        address2: string;
        address3: string;
        address4: string;
        city: string;
        stateCode: string;
        country: string;
        postCode: string;
        type: string;
        smsToken: string;
    }

    export class EmailAddress {

        constructor(id?: number, emailAddressType?: string, email?: string ) {
            this.id = id;
            this.email = email;
            this.emailAddressType = emailAddressType;
        }

        id: number;
        email: string;
        emailAddressType: string;
        smsToken: string;
    }


    export class Portfolio {
        Name: string;
        RiskProfile: string;
        Holdings: Array<Holding>;
        constructor() {
            this.Holdings = new Array<Holding>();
        }
    }

    export class SelectedAccountTotal {
        cashBalanceTotal: number;
        equityTotalCostTotal: number;
        equityMarketValueTotal: number;
        equityProfitLossTotal: number;
        equityEstimatedIncomeTotal: number;

        constructor() {
            this.cashBalanceTotal = 0;
            this.equityTotalCostTotal = 0;
            this.equityMarketValueTotal = 0;
            this.equityProfitLossTotal = 0
            this.equityEstimatedIncomeTotal = 0;
        }
    }

    export class Banner {
        imageUrl: string;
        contentTitle: string;
        contentDescription: string;
        buttonText: string;
        buttonUrl: string;
        isHidden: boolean;
    }

    export interface News {
        imageUrl: string;
        title: string;
        content: string;
        link: string;
        openInNewTab: boolean;
    }
}
